import { Typography } from "@mui/material";
import { Box, styled } from "@mui/system";
import { Link } from "react-router-dom";

export const StyledContainer = styled(Box)(({ theme }) => ({
  background: "white",
  // margin: theme.spacing(1),
  borderRadius: "10px",
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(2),
  boxShadow: `
      0px 1px 2px 0px #00000005,
      0px 3px 3px 0px #00000005,
      0px 7px 4px 0px #00000003,
      0px 12px 5px 0px #00000000,
      0px 18px 5px 0px #00000000
    `,
}));

export const StyledHeader = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(2),
  fontWeight: 600,
  fontSize: "20px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  //   justifyContent: "space-between",
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.myCustomColor.link,
  fontSize: "14px",
  fontWeight: 600,
  textDecorationColor: "#2977CC",
}));

export const StyledUploadSection = styled(Box)(({ theme }) => ({
  paddingY: theme.spacing(1),
  display: "flex",
  flexWrap: "wrap",
}));

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginLeft: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));
